<ng-container *ngrxLet="{ data: containerData$ | async } as vm">
  @if (vm.data) {
    <floori-action-container
      (closeContainer)="closeDialog()"
      [actionButtonViewMap]="actionButtonMap"
      [actionViewMap]="actionViewMap"
      [isDialog]="vm.data.isDialog"
      [isEpoxy]="vm.data.isEpoxy"
      [allowDrag]="vm.data.allowDrag"
      [showCloseButton]="vm.data.showCloseButton"
      [primaryButton]="vm.data.primaryButton"
      [secondaryButton]="vm.data.secondaryButton"
      [tertiaryButton]="vm.data.tertiaryButton"
      [showSelector]="vm.data.showSelector"
      [selectorValue]="vm.data.selectorValue"
      [headerType]="vm.data.headerType"
      [_headerLabel]="vm.data.headerLabel"
      [_headerIcon]="vm.data.headerIcon"
      [_headerMessage]="vm.data.headerMessage"
      [disableHeaderLabelTranslation]="!!vm.data.disableHeaderLabelTranslation"
      [ngClass]="{ 'hidden-ui': vm.data.addHiddenUIClass }">
    </floori-action-container>
  }
</ng-container>
